import { useState } from "react";
import { Link } from "react-router-dom";
import { User } from "lucide-react"; // simple person icon

type Props = {
  userName: string;
  points?: number | null;
};

export function UserMenu({ userName, points }: Props) {
  const [open, setOpen] = useState(false);

  return (
    <div className="relative select-none">
      {/* Toggle */}
      <button
        onClick={() => setOpen(!open)}
        className="flex items-stretch space-x-2 rounded-md px-2 py-1 hover:bg-muted/50 focus:outline-none"
        aria-expanded={open}
        aria-haspopup="menu"
      >
        {/* Icon takes the full height of text block */}
        <User className="h-full w-6 flex-shrink-0 text-muted-foreground" />

        {/* Name + points */}
        <div
          className={
            points ? "flex flex-col justify-between" : "flex flex-col justify-center"
          }
        >
          <span className="text-sm font-medium leading-tight">{userName}</span>
          {points && (
            <span className="text-xs text-muted-foreground leading-tight">
              {points} points
            </span>
          )}
        </div>
      </button>

      {/* Dropdown */}
      {open && (
        <div
          role="menu"
          className="absolute right-0 mt-1 w-32 rounded-md border bg-white shadow-lg"
        >
          <Link
            to="/settings"
            className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
            role="menuitem"
            onClick={() => setOpen(false)}
          >
            Settings
          </Link>
          <Link
            to="/logout"
            className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
            role="menuitem"
            onClick={() => setOpen(false)}
          >
            Logout
          </Link>
        </div>
      )}
    </div>
  );
}